/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DailyOrgSummaryUsageResponse } from './dailyOrgSummaryUsageResponse';


export interface DailyOrgSummaryPaginatedResponse { 
    current_page_size?: number;
    requested_page_number?: number;
    requested_page_size?: number;
    total_pages?: number;
    total_record_count?: number;
    daily_org_summary_usages?: Array<DailyOrgSummaryUsageResponse>;
}

